export default [
{
  title: 'Home',
  to: '/',
  styled: {
    pl: 15,
  },
},
{
  title: 'People',
  to: '/dashboard/people',
  styled: {
    pl: 15,
  },
}
]


// WEBPACK FOOTER //
// ./src/static/menus/MenuMainDashboard/index.js